import type { ReactNode } from 'react'

import { Container } from './Container'
import { IconWrapper } from './IconWrapper'
import { Title } from './Title'

type Props = {
	title: ReactNode
	icon: ReactNode
	children?: ReactNode
}

export const SplashScreen = ({ title, icon, children }: Props) => (
	<Container>
		<div>
			<IconWrapper>{icon}</IconWrapper>
			<Title>{title}</Title>
			{children}
		</div>
	</Container>
)
